/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext, useState, useEffect, createRef } from 'react';
import MetricsContext from './MetricsContext';
import WidgetList from './WidgetList';
import WidgetLab from './WidgetLab';
import WidgetForm from './WidgetForm';
import MetricsHeader from './MetricsHeader';

const Component = (): Element<string> => {
  const ctx = useContext(MetricsContext);
  const isCustomizing = ctx.state.mode === 'CUSTOMIZING';
  const isReady = ctx.state.mode === 'READY';
  const isCreatingWidget = ctx.state.mode === 'NEW_WIDGET';
  const isEditingWidget = ctx.state.mode === 'EDIT_WIDGET';
  const headerRef = createRef();
  const [headerHeight, setHeaderHeight] = useState(0);

  // Header height is the height of the header element. This dynamic
  // value is needed to adjust the padding of the body, so that it
  // fits into the space left by the header inside the container.
  useEffect(() => {
    const el = headerRef.current;
    if (el) {
      setHeaderHeight(el.offsetHeight);
    }
  }, [headerRef]);

  return (
    <div css={css('height: 100%;')}>
      <MetricsHeader ref={headerRef} />
      <div
        css={css(`
            height: 100%;
            overflow-y: scroll;
            padding-bottom: ${headerHeight}px;
            -webkit-overflow-scrolling: touch;
            scroll-snap-type: y mandatory;
          `)}
      >
        {isCustomizing && <WidgetLab />}
        {isReady && <WidgetList />}
        {isCreatingWidget && <WidgetForm />}
        {isEditingWidget && <WidgetForm />}
      </div>
    </div>
  );
};

export default Component;
